<template>
  <div
    v-loading.fullscreen.lock="loading"
    class="BookIndex"
    :element-loading-text="false"
  >
    <div
      :style="{ marginTop: unionFlag ? '20px' : '' }"
      class="advise-banner"
    >
      <LeftNavList
        v-if="catList && catList.length > 0"
        :catList="catList"
        :onChange="
          (id) => {
            toListPage(id);
          }
        "
      />
      <!-- <Carousel
        v-if="bannerImg.length > 0"
        :interval="3000"
        arrow="hover"
        height="455px"
      >
        <CarouselItem
          v-for="(item, index) in bannerImg"
          :key="index"
        >
          <a :href="unionFlag ? (item.bfdUrl ? item.bfdUrl : 'javascript:void(0)') : (item.adUrl ? item.adUrl : 'javascript:void(0)')"  style="cursor:auto;">
            <img
              :src="item.adImg"
              alt
              :style="{ background: '#ccc' }"
            />
          </a>
        </CarouselItem>
      </Carousel> -->
      <Carousel
        indicator-position="none"
        :interval="3000"
        arrow="never"
        height="455px"
      >
        <CarouselItem>
          <a
            href="javascript:void(0)"
            style="cursor: auto"
          >
            <img
              src="./Category/JD_banner.jpg"
              alt
              :style="{ background: '#ccc' }"
            />
          </a>
        </CarouselItem>
      </Carousel>
    </div>

    <div class="goods-wrap">
      <ul ref="goodsWrap">
        <!-- 循环匹配 都按indexCategoryDtos 这个顺序显示 -->
        <div
          v-for="cate in indexCategoryDtos"
          :key="cate.id"
        >
          <li
            v-for="(item, index) in indexCategoryGoodsDtos"
            :key="index"
          >
            <div v-if="cate.id === item.categoryId">
              <div class="header-title">
                <div class="title-left">
                  <span>{{ item.categoryName }}</span>
                  <span class="en">{{ cate.enName }}</span>
                </div>
                <div
                  class="title-right"
                  @click="toListPage(item.categoryId)"
                >
                  <span>{{ TLang("查看更多", "my") }}</span>
                  <i class="icon"></i>
                </div>
              </div>
              <div class="goodsList">
                <div
                  v-for="(goods, i) in item.indexSpuGoodsDtoList"
                  :key="i"
                  class="item"
                >
                  <GoodsItem
                    :goods="goods"
                    :onClick="toDetailPage"
                    :onClickAdd="onClickAdd.bind(undefined, goods)"
                    :purchaseType="cate.purchaseType"
                  />
                </div>
              </div>
            </div>
          </li>
        </div>
      </ul>
    </div>
    <!-- 侧边导航条 -->
    <div
      v-if="isShowSticky"
      class="fixed-menu"
      @mouseenter="showBigNav = true"
      @mouseleave="showBigNav = false"
    >
      <div
        v-if="availWidth >= 1480 || showBigNav"
        class="rich-screen clearfix"
        :style="{
          left: fixedLeft + 'px',
        }"
      >
        <div class="left-nav">
          {{ TLang("楼层导航", "my") }}
        </div>
        <div
          v-for="(item, index) in indexCategoryDtos"
          :key="index"
          :class="{ fixedItem: true, active: index === activeFloor }"
          @click="scrollView(index)"
        >
          <span>{{ item.name }}</span>
        </div>
      </div>
      <div
        v-else
        key="small"
        class="nav-left-small"
        @mouseenter="showBigNav = true"
        v-html="TLang('Floor', 'my')"
      ></div>
    </div>
    <SkuPicker
      :visible="SkuPickerShow"
      :goods="activeGoods"
      :onClose="onCloseSkuModal"
      :onAdd="onClickSkuAdd"
    />
    <FixedButton />
    <Dialog
      title=" "
      :visible.sync="dialogVisible"
      width="420px"
      custom-class="product-dialog"
      center
      top="50vh"
      :lock-scroll="false"
      @open="dialogVisible = true"
    >
      <img :src="require('../../assets/images/cart_ok.png')" />
      <div class="title">
        {{ TLang("加入购物车成功", "my") }}
      </div>
      <div
        v-if="chooseOfAdd.goodsName"
        class="goods-name"
      >
        {{ chooseOfAdd.goodsName }}
      </div>
      <div
        v-if="chooseOfAdd.specValue1 || chooseOfAdd.specName"
        class="goods-sku-name"
      >
        {{ TLang("规格", "my") }}：{{
          chooseOfAdd.specValue1 || chooseOfAdd.specName
        }}
      </div>
      <div class="btns">
        <button
          class="close-btn"
          @click="toDetail(chooseOfAdd)"
        >
          {{ TLang("查看商品详情", "my") }}
        </button>
        <button
          class="buy-btn primary"
          @click="onClickGoBuy"
        >
          {{ TLang("去结算", "my") }}
        </button>
      </div>
    </Dialog>
  </div>
</template>

<script>
import LeftNavList from "./LeftNavList";
import GoodsItem from "./GoodsItem";
import { CarouselItem, Carousel } from "element-ui";
import SkuPicker from "@components/SkuPicker";
import FixedButton from "@components/FixedButton";
import { Dialog } from "element-ui";
import {
  fetchLifeIndex,
  fetchProductListById,
  getBookAds,
  fetchGoodsTags,
} from "@fetch";
import { fetchaddCart, fetchSkuBySpuId, getActivityTag } from "@fetch/shopping";
import Cookies from "js-cookie";
import { unionFlag } from "@utils";
import { dealTagGoods } from "@/utils/special";
import { mapActions, mapGetters } from "vuex";
export default {
  name: "BookIndex",
  components: {
    LeftNavList,
    Carousel,
    CarouselItem,
    GoodsItem,
    SkuPicker,
    Dialog,
    FixedButton,
  },
  data() {
    return {
      loading: true,
      catList: [],
      hotList: [],
      bannerImg: [],
      indexCategoryGoodsDtos: [],
      indexCategoryDtos: [],
      activeFloor: 0,
      isShowSticky: false,
      availWidth: 100,
      scrollList: [],
      SkuPickerShow: false,
      activeGoods: {},
      chooseOfAdd: {},
      dialogVisible: false,
      addressInfo:
        Cookies.get("address") && JSON.parse(Cookies.get("address") || "{}"),
      fixedLeft: 0,
      unionFlag: unionFlag(),
      currentIndex: 1,
      showBigNav: false,
    };
  },
  computed: {
    ...mapGetters("shopCart", ["getCount"]),
    getGoodTagsParams() {
      const goodsList = [];
      this.indexCategoryGoodsDtos.forEach((item) => {
        item.indexSpuGoodsDtoList.forEach((good) => {
          if (item.categoryId)
            goodsList.push({
              categoryId: good.categoryId,
              goodsId: good.goodsId,
            });
        });
      });
      return goodsList;
    },
  },
  created() {
    fetchLifeIndex({ channelId: "999" }).then((res) => {
      if (res) {
        this.loading = false;
        this.catList = res.indexCategoryDtos;
        // this.catList = res.shopCategories;
        // this.bannerImg = res.advertisingWheelDtos;
        this.indexCategoryGoodsDtos = res.indexCategoryGoodsDtos;
        this.getGoodsTags();
        this.indexCategoryDtos = res.indexCategoryDtos;
        // 等待dom渲染完 拿到各楼层位置
        setTimeout(() => {
          this.handleScroll();
        }, 1000);
      }
    });
    this.cartCount({ ...this.addressInfo });
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
    window.addEventListener("resize", this.listenResize);
    this.availWidth =
      document.body.offsetWidth || document.documentElement.offsetWidth;
    this.computeLeft(this.availWidth >= 1480 ? 160 : 120);
  },

  destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
    window.removeEventListener("resize", this.listenResize);
    this.$bus.$emit("onSticky", false);
  },

  methods: {
    ...mapActions("shopCart", ["cartCount"]),
    handleScroll() {
      // f滚动时，左侧菜单高亮
      let scrollTop =
        document.documentElement.scrollTop || document.body.scrollTop;
      let len = this.$refs.goodsWrap.children.length;
      this.scrollList = [];
      for (let i = 0; i < len; i++) {
        this.scrollList.push(this.$refs.goodsWrap.children[i].offsetTop - 120);
      }
      for (let j = 0; j < this.scrollList.length; j++) {
        if (
          scrollTop > this.scrollList[j] &&
          scrollTop <= this.scrollList[j + 1]
        ) {
          this.activeFloor = j;
          continue;
        }
        if (scrollTop >= this.scrollList[this.scrollList.length - 1]) {
          this.activeFloor = this.scrollList.length - 1;
        }
      }
      this.isShowSticky = scrollTop >= 80;
      this.$bus.$emit("onSticky", this.isShowSticky);
    },
    listenResize() {
      this.availWidth =
        document.body.offsetWidth || document.documentElement.offsetWidth;
      this.computeLeft(this.availWidth >= 1480 ? 160 : 120);
    },
    computeLeft(width) {
      // this.fixedLeft = (this.availWidth - 1200) / 2 - width;
      let showLeft = (this.availWidth - 1200) / 2 - width;
      this.fixedLeft = showLeft > 0 ? showLeft : 0;
    },
    scrollView(i) {
      this.$refs.goodsWrap.children[i].scrollIntoView({
        behavior: "smooth",
      });
    },
    toListPage(cat) {
      window.open(
        `product/JDList?categoryId=${cat}&channelId=999`,
        this.isFeishuOrDingding ? "_self" : "_blank",
      );
    },
    toDetailPage(goods) {
      if (goods.goodsType === 0) {
        window.open(
          `/shop/product/detail?cid=${goods.categoryId}&gid=${goods.goodsId}`,
          this.isFeishuOrDingding ? "_self" : "_blank",
        );
        // window.location.href = `/shop/product/detail?cid=${goods.categoryId}&gid=${goods.goodsId}`;
      } else if (goods.goodsType === 1) {
        let url = `/birthday/goods/detail/${goods.spuId}?city=${
          this.addressInfo.cityId || 145
        }`;
        if (goods.pcUrl){
          url = goods.pcUrl;
        }
        window.open(
          url,
          this.isFeishuOrDingding ? "_self" : "_blank",
        );
        // window.location.href = `/birthday/goods/detail/${goods.spuId}?city=${this.addressInfo.cityId || 145}`;
      }
    },
    onCloseSkuModal() {
      this.SkuPickerShow = false;
    },
    onClickAdd(goods) {
      fetchSkuBySpuId({
        categoryId: goods.categoryId,
        spuId: goods.spuId,
      }).then((body) => {
        if (body) {
          // 单规格
          if (body.length === 1) {
            const myChoose = {
              categoryId: body[0].categoryId,
              goodsId: body[0].goodsId,
              num: body[0].buyMin || 1,
            };
            this.onClickSkuAdd(myChoose);
            return;
          }
          try {
            let checkList = [];
            body &&
              body.length > 0 &&
              body.forEach((item) => {
                item.tags = [];
                if (item.categoryId && item.goodsId) {
                  checkList.push({
                    categoryId: item.categoryId,
                    goodsId: item.goodsId,
                  });
                }
              });
            checkList &&
              checkList.length > 0 &&
              getActivityTag({
                channel: 2,
                goodsList: checkList,
              }).then((res) => {
                if (res && res.length > 0) {
                  body &&
                    body.length > 0 &&
                    body.forEach((item) => {
                      item = dealTagGoods(item, res);
                    });
                  this.activeGoods = goods;
                  this.activeGoods.goodsSpecList = body;
                  this.SkuPickerShow = true;
                } else {
                  this.activeGoods = goods;
                  this.activeGoods.goodsSpecList = body;
                  this.SkuPickerShow = true;
                }
              });
          } catch (error) {
            this.activeGoods = goods;
            this.activeGoods.goodsSpecList = body;
            this.SkuPickerShow = true;
          }
        }
        if (body.msg) {
          Toast.info(body.msg, 1);
        }
      });
    },
    onClickSkuAdd(myChoose) {
      this.chooseOfAdd = myChoose;
      fetchaddCart({
        categoryId: myChoose.categoryId,
        goodsId: myChoose.goodsId,
        goodsNum: myChoose.num,
        ...this.addressInfo,
      }).then((body) => {
        if (body) {
          this.dialogVisible = true;
          this.cartCount({ ...this.addressInfo });
        }
        if (body.msg) {
          Toast.info(body.msg, 1);
        }
      });
      this.onCloseSkuModal();
    },
    toDetail(goods) {
      window.open(
        `/shop/product/detail?cid=${goods.categoryId}&gid=${goods.goodsId}`,
        this.isFeishuOrDingding ? "_self" : "_blank",
      );
      // window.location.href = `/shop/product/detail?cid=${goods.categoryId}&gid=${goods.goodsId}`;
    },
    onClickGoBuy() {
      window.open(
        "/shop/shopping/cart",
        this.isFeishuOrDingding ? "_self" : "_blank",
      );
      // window.location.href = '/shop/shopping/cart';
    },
    carouselChange: function(key1, key2) {
      //目前激活的幻灯片的索引和原幻灯片的索引
      // console.log(key1 + ",,,," + key2);
      this.currentIndex = Number(key1) + 1;
    },
    // 商品数据拼接tag
    goodsListAddFlag(res) {
      this.indexCategoryGoodsDtos.forEach((item) => {
        item.indexSpuGoodsDtoList.forEach((good) => {
          const goodTag =
            res.find(
              (tag) =>
                tag.categoryId == good.categoryId && tag.goodsId == good.goodsId,
            ) || {};
          let tags = goodTag && goodTag.tags ? goodTag.tags : [];
          if (tags && tags.length > 0) {
            //type  1特价抢购   满减     2爆炸贴       3新品
            //mktFrontType   1001 特价 1004 抢购  2001 满减  9001 新品 300001抽奖
            // 京东优选展示新品标签/特价抢购标签,不展示满减标签
            tags = tags.filter(
              (item) =>
                item.type === 3 ||
                item.mktFrontType === 1001 ||
                item.mktFrontType === 1004 ||
                item.mktFrontType === 9003 ||
                item.mktFrontType === 9004 ||
                item.mktFrontType === 9005,
            );
          }
          const promPrice = goodTag && goodTag.tags ? goodTag.promPrice : null;
          const salePrice = goodTag && goodTag.tags ? goodTag.salePrice : null;
          const bizStock =
            goodTag && goodTag.bizStock >= 0 ? goodTag.bizStock : null;
          this.$set(good, "tags", tags);
          this.$set(good, "promPrice", promPrice);
          this.$set(good, "salePrice", salePrice);
          this.$set(good, "bizStock", bizStock);
          // 拼接折扣信息
          this.$set(good, "discount", goodTag.discount);
          this.$set(good, "discountPrice", goodTag.discountPrice);
          this.$set(good, "discountTagShow", goodTag.discountTagShow);
          this.$set(good, "mktTagShow", goodTag.mktTagShow);
        });
      });
    },
    // 获取商品tag
    getGoodsTags() {
      if (this.getGoodTagsParams && this.getGoodTagsParams.length > 0) {
        fetchGoodsTags({ goodsList: this.getGoodTagsParams, channel: 2 }).then(
          (res) => {
            if (res && res.length > 0) {
              this.goodsListAddFlag(res);
            }
          },
        );
      }
    },
  },
};
</script>

<style lang="less">
.BookIndex {
  .tabs {
    font-size: 14px;
    margin-bottom: 20px;
    display: flex;
    align-items: center;
    a {
      color: #666;
      text-align: center;
      line-height: 28px;
      border-radius: 5px;
    }
    img {
      width: 16px;
      height: 16px;
      margin: auto 5px;
    }
    span {
      line-height: 30px;
      color: #666;
      text-align: center;
      border-radius: 5px;
    }
  }
  .advise-banner {
    display: flex;
    padding-top: 44px;
    overflow-y: hidden;
    margin-left: -20px;
    /deep/ .cat-list {
      width: 220px;
      margin-top: -44px;
    }
    .el-carousel {
      flex: 1;
      .el-carousel__container {
        a {
          display: inline-block;
          width: 100%;
          img {
            width: 1200px;
            height: 450px;
          }
        }
        .el-carousel__arrow {
          width: 50px !important;
          height: 100px !important;
          border-radius: 0;
          i {
            font-size: 35px;
            color: #ededed;
            opacity: 0.9;
          }
        }
        .el-carousel__arrow--left {
          left: 0;
        }
        .el-carousel__arrow--right {
          right: 0;
        }
      }
      .el-carousel__indicators {
        .el-carousel__button {
          width: 10px;
          height: 10px;
          background: rgba(255, 255, 255, 1);
          border-radius: 50%;
        }
      }
    }
  }
  .goods-wrap {
    padding-top: 30px;
    ul {
      li {
        margin-bottom: 60px;
        .header-title {
          display: flex;
          justify-content: space-between;
          padding-bottom: 10px;
          border-bottom: 1px solid #f0f0f0;
          align-items: baseline;
          padding-top: 140px;
          margin-top: -140px;
          .title-left {
            font-size: 24px;
            color: rgba(51, 51, 51, 1);
            // margin-left: 20px;
            .en {
              font-size: 14px;
              color: rgba(204, 204, 204, 1);
            }
          }
          .title-right {
            display: flex;
            align-items: center;
            .icon {
              float: right;
              width: 8px;
              height: 10px;
              margin-left: 10px;
              margin-top: 1px;
              background: url("./GoodsItem/more.png") center center no-repeat;
              background-size: 8px 10px;
            }
            &:hover {
              cursor: pointer;
            }
          }
        }
        .goodsList {
          display: flex;
          flex-wrap: wrap;
          .item {
            margin-right: 12px;
            padding: 15px 0;
            margin-top: 10px;
            &:hover {
              box-shadow: 0px 4px 14px 0px rgba(0, 0, 0, 0.05);
            }
          }
          .item:nth-child(5n) {
            margin-right: 0;
          }
        }
      }
    }
  }
  .fixed-menu {
    position: fixed;
    // box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.1);
    // background: #fff;
    background: transparent;
    top: 100px;
    left: 0;
    width: auto;
    min-width: 40px;
    text-align: center;
    z-index: 1000;
    // overflow: hidden;
    .rich-screen {
      width: 144px;
      box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.1);
      background: #fff;
      position: relative;
      top: 0;
      transition: all 0.3s ease-in;
      .left-nav {
        font-size: 18px;

        line-height: 44px;
        text-align: center;
        color: #fff;
        width: 100%;
        height: 44px;
        // background:linear-gradient(327deg,rgba(124,177,208,1) 0%,rgba(70,121,163,1) 100%);
        background: #247dff;
      }
    }
    .nav-left-small {
      position: relative;
      top: 0;
      left: 0;
      z-index: 999;
      font-size: 20px;
      padding: 16px 6px;
      font-weight: bold;
      // background:linear-gradient(327deg,rgba(124,177,208,1) 0%,rgba(70,121,163,1) 100%);
      background: #247dff;
      color: #fff;
      line-height: 26px;
      // text-shadow:0px 6px 16px rgba(0,0,0,0.15), 0px 2px 4px rgba(194,71,70,0.75);
      border-radius: 0px 8px 8px 0px;
      writing-mode: vertical-lr;
      transition: all 0.3s ease-in;
    }
    .fixedItem {
      float: left;
      font-size: 14px;
      color: #333;
      background: #fff;
      margin: 0;
      padding: 11px 0;
      height: 36px;
      box-sizing: border-box;
      text-align: center;
      max-width: 72px;
      overflow: hidden;
      span {
        display: block;
        line-height: 14px;
        height: 14px;
        width: 100%;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      &:nth-of-type(even) span {
        width: 71px;
        border-right: 1px solid #f0f0f0;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      &:nth-of-type(odd) span {
        width: 71px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
    .fixedItem.active {
      color: #4679a3;
      background: #fff;
    }
    .fixedItem:hover {
      color: #333;
      background: #ecf5fd;
      cursor: pointer;
    }
  }
  .header-body-sticky {
    position: fixed;
    top: 0;
    background: #fff;
    z-index: 999;
    box-shadow: 0 8px 8px -4px rgba(0, 0, 0, 0.05);
  }
  /deep/ .product-dialog {
    .title {
      margin-top: 18px;
    }
    .goods-name {
      color: #7f7f7f;
      margin-top: 18px;
    }
    .goods-sku-name {
      color: #b2b2b2;
      margin-top: 5px;
    }
  }
}
</style>
